import { QuoteLineData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const quoteLineApi = apiResource<QuoteLineData>('quote-lines');
